/**
 * 个人证书导入 2020-09-21
 */
import React from 'react';
import { connect } from 'dva';

import { component_tool, framework_tool } from '@/tool'
let { WizTypography, WizSpin,WizSelect,WizBrowserExport } = component_tool;
let { WizContainer } = framework_tool;
const { Paragraph } = WizTypography;
import { ExportExcel } from '@/components/index'
import { modelUtils } from '@/utils'
import {Dropdown, Select} from "antd";

class CertLinkImport extends WizContainer {

  componentName = 'studentAbilityFileImport';

  constructor(props) {
    super(props);
    this.state = {
      type:null
    }
  }

  _handldImport(nextProps, nextState) {
    let o = nextProps['studentAbilityItemImport']
    if (o['success']) {
      let data = o['data'];
      let str = data.replace(/<br\/>/g,"\n")
      wizNotice.success({
        key:'default',
        message:'成功',
        description: (
          <div>
            <p style={{whiteSpace: "pre-line"}}>{str}</p>
          </div>
        ),
      })
      return true;
    } else {
      wizNotice.error({ key:'certLink-error',message:'出错了', description: <div dangerouslySetInnerHTML={{ __html: o.msg || "导入失败" }} /> })
      return false;
    }
  }


  _getTemp(type) {
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '账号',
        field: 'account',
        width: 25,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '证书名称',
        field: 'name',
        width: 25,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '所属经销商代码',
        field: 'code',
        width: 25,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      }
    ]

      WizBrowserExport({
        sheetName: '证书挂靠导入模版',
        columns: columnDefs.filter((_, index) => index),
        rows: [{'account':'zhangsan','name':'销售一星证书','code':'CH1856,2200654'}],
        filename: '证书挂靠导入.xlsx',
      })
      return true;
  }



  propsAndStateOnChange = {
    studentAbilityItemImport: this._handldImport.bind(this),
  }


  _render() {
    let infoProps = {
      title: '导入说明',
      text: [
        <Paragraph>1、从模版链接中下载模版文件</Paragraph>,
        <Paragraph>2、按照要求格式填写信息</Paragraph>,
        <Paragraph>3、当完成Excel文件的填写后，点击“上传文件”按钮上传此文件</Paragraph>,
      ]
    }
    let operateProps = {
      title: '证书挂靠数据导入',
      template: {
        label: '模版下载',
        fileName: '模版.xlsx',
        onClick:()=>{this._getTemp(this.state.type)},
      }
    }
      let submit = (file, fileData) => {

      let apiPath = 'certLink/importFile';
      this.doAction({
        path: apiPath,
        payload: {
          key: "import",
          apiParams: {
            fileData
          }
        }
      });
    }


    let { studentAbilityItemLoading } = this.props;
    return (
      <WizSpin tip={'文件上传中'} spinning={studentAbilityItemLoading}>
        <ExportExcel
          infoProps={infoProps}
          operateProps={operateProps}
          // other={other}
          submit={submit}
        />
      </WizSpin>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { studentAbilityItem,certLink } = state;
  const studentAbilityItemImport = modelUtils.getModelEntity(certLink, 'import');
  const studentAbilityItemExportHead = modelUtils.getModelEntity(studentAbilityItem, 'studentAbilityItemExportHead');

  //获取loading的方式
  const load = modelUtils.getLoadingState(state, 'studentAbilityItem')
  return {
    studentAbilityItemImport: studentAbilityItemImport,
    studentAbilityItemExportHead:studentAbilityItemExportHead,
    ...load
  }
};

export default connect(mapStateToProps)(CertLinkImport);
